/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoriaCaricoDTO
 */
export interface CategoriaCaricoDTO {
    /**
     * 
     * @type {number}
     * @memberof CategoriaCaricoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoDTO
     */
    codice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CategoriaCaricoDTO
     */
    attivo?: boolean;
}

/**
 * Check if a given object implements the CategoriaCaricoDTO interface.
 */
export function instanceOfCategoriaCaricoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CategoriaCaricoDTOFromJSON(json: any): CategoriaCaricoDTO {
    return CategoriaCaricoDTOFromJSONTyped(json, false);
}

export function CategoriaCaricoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoriaCaricoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'codice': !exists(json, 'codice') ? undefined : json['codice'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
    };
}

export function CategoriaCaricoDTOToJSON(value?: CategoriaCaricoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'codice': value.codice,
        'descrizione': value.descrizione,
        'attivo': value.attivo,
    };
}

